import { render, staticRenderFns } from "./OnlineRoom.vue?vue&type=template&id=40fc465c&scoped=true"
import script from "./OnlineRoom.vue?vue&type=script&lang=js"
export * from "./OnlineRoom.vue?vue&type=script&lang=js"
import style0 from "./OnlineRoom.vue?vue&type=style&index=0&id=40fc465c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc465c",
  null
  
)

export default component.exports